import { Field, Entity } from "typegraph";
import IEntity from "core/util/IEntity";


// tslint:disable
@Entity({ update: "topicBookmark" })
class TopicBookmark implements IEntity {
  @Field({ aliasFor: "entityId" })
  public id: string;
 
 @Field()
  public message?: string;
}
export default TopicBookmark;


// WEBPACK FOOTER //
// ./src/panels/forum/entity/topicBookmark.ts